import { useEffect, useState } from 'react';
import AnneescolaireService from '../../services/AnneescolaireService';

const useYearAndTrimester = () => {
	const [yearOptions, setYearOptions] = useState([]);
	const [selectedYear, setSelectedYear] = useState({});
	const [selectedTrimester, setSelectedTrimester] = useState('');

	useEffect(() => {
		const fetchYearOptions = async () => {
			try {
				const years = await AnneescolaireService.getYearOptions();
				setYearOptions(years);

				const currentYear =
					await AnneescolaireService.getCurrentAnneescolaire();
				setSelectedYear(currentYear.data);

				const currentTrimester = await AnneescolaireService.getCurrentTrimester(
					currentYear.data
				);
				setSelectedTrimester(currentTrimester || 1);
			} catch (error) {
				console.error('Error fetching year options', error);
			}
		};

		fetchYearOptions();
	}, []);

	const handleYearChange = async (yearId) => {
		try {
			const year = await AnneescolaireService.getAnneescolaire(yearId);
			setSelectedYear(year.data || {});

			const currentTrimester = await AnneescolaireService.getCurrentTrimester(
				yearId
			);
			setSelectedTrimester(currentTrimester || 1);
		} catch (error) {
			console.error('Error fetching year or trimester', error);
			setSelectedTrimester(1);
		}
	};

	return {
		yearOptions,
		selectedYear,
		selectedTrimester,
		handleYearChange,
		setSelectedTrimester
	};
};

export default useYearAndTrimester;
